import { render, staticRenderFns } from "./CanvasEditor.vue?vue&type=template&id=006483a3&scoped=true&"
import script from "./CanvasEditor.vue?vue&type=script&lang=js&"
export * from "./CanvasEditor.vue?vue&type=script&lang=js&"
import style0 from "./CanvasEditor.vue?vue&type=style&index=0&id=006483a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006483a3",
  null
  
)

export default component.exports